module.exports = __webpack_public_path__ + "img/balkon12.7fb92b7e.jpg";